<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
  [fullScreen]="true">
  <span class="loader">
    <img width="150px" src="/assets/media/logos/logo-wegestu-color.png" alt="">
  </span>
</ngx-spinner>

<!--begin::Main-->
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">

    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <div class="d-flex align-items-center">
            <h1 class="page-heading mt-0 mb-0">
              <svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_679_2720)">
                  <path
                    d="M30.0547 0H5.94526C4.88421 0 4 0.820629 4 1.80538V18.7377C4 19.7224 4.88421 20.5431 5.94526 20.5431H30.0547C31.1158 20.5431 32 19.7224 32 18.7377V1.80538C32 0.793275 31.1158 0 30.0547 0ZM12.3116 1.86009C12.7832 1.86009 13.1368 2.2157 13.1368 2.62601C13.1368 3.06368 12.7537 3.39193 12.3116 3.39193C11.84 3.39193 11.4863 3.03633 11.4863 2.62601C11.4568 2.18834 11.84 1.86009 12.3116 1.86009ZM9.77684 1.86009C10.2484 1.86009 10.6021 2.2157 10.6021 2.62601C10.6021 3.06368 10.2189 3.39193 9.77684 3.39193C9.30526 3.39193 8.95158 3.03633 8.95158 2.62601C8.9221 2.18834 9.30526 1.86009 9.77684 1.86009ZM7.21263 1.86009C7.68421 1.86009 8.03789 2.2157 8.03789 2.62601C8.03789 3.06368 7.65474 3.39193 7.21263 3.39193C6.77053 3.39193 6.38737 3.03633 6.38737 2.62601C6.38737 2.18834 6.77053 1.86009 7.21263 1.86009ZM29.4947 18.0538C29.4947 18.1359 29.4358 18.1906 29.3474 18.1906H6.65263C6.56421 18.1906 6.50526 18.1359 6.50526 18.0538V5.27938H29.4947V18.0538Z"
                    fill="#265D91" />
                  <path
                    d="M10.7766 12.8291H13.7829C14.1956 12.8291 14.5787 12.6376 14.785 12.282L15.8756 10.5587L19.0882 15.5646C19.2945 15.8928 19.6777 16.1116 20.0903 16.1116C20.5029 16.1116 20.8861 15.9202 21.0924 15.5646L22.8608 12.8018H25.1892C25.8377 12.8018 26.3682 12.3094 26.3682 11.7076C26.3682 11.1058 25.8377 10.6134 25.1892 10.6134H22.2124C21.7998 10.6134 21.4166 10.8049 21.2103 11.1605L20.1198 12.8838L16.9071 7.878C16.4945 7.22149 15.3156 7.22149 14.8734 7.878L13.105 10.6408H10.7766C10.1282 10.6408 9.59766 11.1332 9.59766 11.735C9.59766 12.3367 10.1282 12.8291 10.7766 12.8291Z"
                    fill="#265D91" />
                </g>
                <defs>
                  <filter id="filter0_d_679_2720" x="0" y="0" width="36" height="28.5431" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_679_2720" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_679_2720" result="shape" />
                  </filter>
                </defs>
              </svg>


              Workflow
            </h1>
            <!--begin::Menu-->
          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a routerLink="/accueil" class="text-muted ">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted cursor-pointer" routerLink="/cra">CRA</li>

            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Workflow</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->

          <div class="card-body tools" [formGroup]="searchForm">
            <div class="title mb-10">
              <h4>Recherche</h4>
            </div>

            <div class="row mb-3">
              <div class="col-lg-3">
                <ng-select [items]="workflowType" bindLabel="nametype" formControlName="type" bindValue="id"
                  [notFoundText]="'Aucun élément trouvé'" class="mb-3" [placeholder]="'Choisir le type :'" autoComplete>
                </ng-select>
              </div>
              <div class="col-lg-3">
                <input type="text" name="client" id="client" class="form-control form-control-solid mb-3"
                  placeholder="Nom du consultant" formControlName="consultant">
              </div>

              <div class="col-lg-3">
                <div class="position-relative d-flex align-items-center mb-3 calenderDate">
                  <p-calendar placeholder="Date de création du workflow" name="date" id="date"
                    formControlName="created_at" class="form-control mb-3" onfocus="(this.type='date')"
                    onblur="(this.type='text')"></p-calendar>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="mb-3 search-btn d-flex justify-content-end">
                  <div class="align-items-center recherche">
                    <button type="submit" class="me-5" (click)="currentPage=0;searchCra(); startSearching = true">
                      <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                          fill="white" />
                      </svg>
                      Rechercher</button>
                  </div>
                  <div class="resett-btn">
                    <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Réinitialiser">
                      <a> <img src="/assets/media/icons/reset.png" alt="" width="30px" (click)=" reset()"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Content container-->
    </div>
    <!--begin::Content-->

    <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card content-table">
          <div class="d-flex flex-wrap header-grid align-items-center mb-5">
            <div class="section_title">
              <h1 class="section-heading my-0">Liste des workflows</h1>
            </div>
            <div class="d-flex justify-content-between align-items-center flex-column">
              <div class="dropdown" *ngIf="!isIntervenant()">
                <button class="dropdown-toggle new-workflow" type="button" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  routerLink="/cra/workflowConsultant">Créer un workflow</button>
              </div>
              <ul class="nav nav-pills mt-10" *ngIf="listWorkFlow && listWorkFlow?.length">
                <li class="nav-item m-0">
                  <a class="btn btn-sm btn-icon  btn-color-muted btn-active-primary  me-3" data-bs-toggle="tab"
                    href="#kt_project_targets_card_pane">
                    <i class="ki-duotone ki-element-plus fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </a>
                </li>
                <li class="nav-item m-0">
                  <a class="btn btn-sm btn-icon  btn-color-muted btn-active-primary active" data-bs-toggle="tab"
                    href="#kt_project_targets_table_pane">
                    <i class="ki-duotone ki-row-horizontal fs-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </a>
                </li>
              </ul>
            </div>

          </div>
          <div class="card-body pt-0">
            <div class="tab-content for-web">
              <div id="kt_project_targets_card_pane" class="tab-pane fade">
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div class="col-md-6 col-xxl-4" *ngFor="let workflow of listWorkFlow">
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <!--begin::Card body-->
                      <div class="d-flex justify-content-end">
                        <div class="dropdown">
                            <button
                              class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                              type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                              aria-expanded="false">
                              <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                  fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                              </svg>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" style="cursor: pointer;"
                                routerLink="/cra/DetailWorkflow/{{workflow?.id}}">Voir détails</a>
                              <a *ngIf="!isIntervenant()" class="dropdown-item" style="cursor: pointer;"
                                routerLink="/cra/modifierworkflow/{{workflow?.id}}">Modifier
                              </a>
                              <a mat-menu-item *ngIf="workflow?.type == workFlowTypeEnum.CONSULTANT && !isIntervenant()"
                                class="dropdown-item" style="cursor: pointer;"
                                (click)="deleteWorkFlowConsultant(workflow?.id)">Supprimer
                              </a>
                            </div>
                        </div>
                      </div>
                      <div class="card-body d-flex flex-center flex-column gap-3">

                        <ng-container>
                          <div class="skills" *ngIf="workflow?.consultants?.length > 0; else emptyConsultant"
                            [ngbTooltip]="workflow?.consultants?.length > 3 ? getConsultantsNames(workflow?.consultants) : null">
                            <div class="skill" *ngFor="let consultant of workflow?.consultants?.slice(0, 3); let i = index">
                              <span class="badge" [ngClass]="i % 2 === 0 ? 'skill-content' : 'skill-desc'">
                                {{consultant.first_name}} {{consultant.last_name}}
                              </span>
                            </div>
                            <div *ngIf="workflow?.consultants.length > 3" class="more-icon">
                              <i class="fa fa-ellipsis-h"></i>
                            </div>
                          </div>
                          <ng-template #emptyConsultant><span>---</span></ng-template>
                        </ng-container>









                        <span class="remote"> {{workflow?.type== workFlowTypeEnum.GENERAL ?'Géneral': workflow?.type ==
                          workFlowTypeEnum.CONSULTANT ? 'Consultant':'---'}}</span>
                        <span class="remote"><span> Date : {{ workflow?.created_at !== null ? (workflow?.created_at |
                            date:'dd/MM/yyyy') : '---' }}</span></span>
                      </div>
                      <div class="sep"></div>
                      <div class="foot p-5">
                        <div class="plus">
                          <a routerLink="/cra/DetailWorkflow/{{workflow?.id}}" style="cursor: pointer;">Visualiser</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pagination mt-5 pt-5" *ngIf="listWorkFlow && listWorkFlow?.length">
                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                      [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                      aria-label="Select page">
                    </mat-paginator>
                  </div>
                  <app-empty-state *ngIf="listWorkFlow && !listWorkFlow?.length" [title]="parentItem"></app-empty-state>
                </div>
              </div>
              <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                <div class="content">
                  <div class="card-body pt-3">

                    <!--begin::Table-->
                    <div class="table-responsive" *ngIf="listWorkFlow && listWorkFlow?.length">
                      <table class="table align-middle gy-5 style-table" id="kt_customers_table">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bold text-uppercase gs-0">
                            <!-- <th class="min-w-125px">ID-workflow</th> -->
                            <th class="min-w-125px">Type</th>
                            <th class="min-w-125px">CONSULTANTS</th>
                            <th class="min-w-125px">Date de création</th>
                            <th class="min-w-90px">Actions</th>
                          </tr>
                        </thead>
                        <tbody class="fw-semibold text-gray-600">
                          <tr *ngFor="let workflow of listWorkFlow">
                            <td>
                              <span>
                                {{workflow?.type== workFlowTypeEnum.GENERAL ?'Géneral': workflow?.type ==
                                workFlowTypeEnum.CONSULTANT ? 'Consultant':'---'}}
                              </span>
                            </td>

                            <td>
                              <ng-container>
                                <div *ngIf="workflow?.consultants?.length > 0; else emptyConsultant"
                                  [ngbTooltip]="workflow?.consultants?.length > 3 ? getConsultantsNames(workflow?.consultants) : null">
                                  <div *ngFor="let consultant of workflow?.consultants?.slice(0, 3); let i = index">
                                    <span>
                                      {{consultant.first_name}} {{consultant.last_name}}
                                    </span>
                                  </div>
                                  <div *ngIf="workflow?.consultants.length > 3" class="more-icon">
                                    <i class="fa fa-ellipsis-h"></i>
                                  </div>
                                </div>
                                <ng-template #emptyConsultant><span>---</span></ng-template>
                              </ng-container>
                            </td>

                            <td>
                              <span>
                                {{ workflow?.created_at !== null ? (workflow?.created_at | date:'dd/MM/yyyy') : '---' }}
                              </span>
                            </td>

                            <td>
                              <div class="dropdown">
                                <button mat-button [matMenuTriggerFor]="menu"
                                  class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                  type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false">
                                  <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                      fill="#265D91" />
                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                      transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                      transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                  </svg>
                                </button>
                                <mat-menu #menu="matMenu">
                                  <a mat-menu-item class="dropdown-item" style="cursor: pointer;"
                                    routerLink="/cra/DetailWorkflow/{{workflow?.id}}">Voir détails</a>
                                  <a mat-menu-item *ngIf="!isIntervenant()" class="dropdown-item"
                                    style="cursor: pointer;"
                                    routerLink="/cra/modifierworkflow/{{workflow?.id}}">Modifier
                                  </a>
                                  <button mat-menu-item
                                    *ngIf="workflow?.type == workFlowTypeEnum.CONSULTANT && !isIntervenant()"
                                    class="dropdown-item" style="cursor: pointer;"
                                    (click)="deleteWorkFlowConsultant(workflow?.id)">Supprimer
                                  </button>
                                </mat-menu>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!--end::Table-->
                    <div class="pagination mt-5 pt-5" *ngIf="listWorkFlow && listWorkFlow?.length">
                      <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                        [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                        aria-label="Select page">
                      </mat-paginator>
                    </div>
                    <app-empty-state *ngIf="listWorkFlow && !listWorkFlow?.length"
                      [title]="parentItem"></app-empty-state>
                  </div>
                </div>
              </div>

            </div>
            <div class="tab-content for-mobile">
              <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div class="col-md-6 col-xxl-4" *ngFor="let workflow of listWorkFlow">
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <!--begin::Card body-->
                      <div class="d-flex justify-content-end">
                        <div class="dropdown">
                            <button
                              class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                              type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                              aria-expanded="false">
                              <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                  fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                  transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                              </svg>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" style="cursor: pointer;"
                                routerLink="/cra/DetailWorkflow/{{workflow?.id}}">Voir détails</a>
                              <a *ngIf="!isIntervenant()" class="dropdown-item" style="cursor: pointer;"
                                routerLink="/cra/modifierworkflow/{{workflow?.id}}">Modifier
                              </a>
                              <a mat-menu-item *ngIf="workflow?.type == workFlowTypeEnum.CONSULTANT && !isIntervenant()"
                                class="dropdown-item" style="cursor: pointer;"
                                (click)="deleteWorkFlowConsultant(workflow?.id)">Supprimer
                              </a>
                            </div>
                        </div>
                      </div>
                      <div class="card-body d-flex flex-center flex-column gap-3">
                        <ng-container>
                          <div class="skills" *ngIf="workflow?.consultants?.length > 0; else emptyConsultant"
                            [ngbTooltip]="workflow?.consultants?.length > 3 ? getConsultantsNames(workflow?.consultants) : null">
                            <div class="skill" *ngFor="let consultant of workflow?.consultants?.slice(0, 3); let i = index">
                              <span class="badge" [ngClass]="i % 2 === 0 ? 'skill-content' : 'skill-desc'">
                                {{consultant.first_name}} {{consultant.last_name}}
                              </span>
                            </div>
                            <div *ngIf="workflow?.consultants.length > 3" class="more-icon">
                              <i class="fa fa-ellipsis-h"></i>
                            </div>
                          </div>
                          <ng-template #emptyConsultant><span>---</span></ng-template>
                        </ng-container>
                        <span class="remote"> {{workflow?.type== workFlowTypeEnum.GENERAL ?'Géneral': workflow?.type ==
                          workFlowTypeEnum.CONSULTANT ? 'Consultant':'---'}}</span>
                        <span class="remote"><span> Date : {{ workflow?.created_at !== null ? (workflow?.created_at |
                            date:'dd/MM/yyyy') : '---' }}</span></span>
                      </div>
                      <div class="sep"></div>
                      <div class="foot p-5">
                        <div class="plus">
                          <a routerLink="/cra/DetailWorkflow/{{workflow?.id}}" style="cursor: pointer;">Visualiser</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pagination mt-5 pt-5" *ngIf="listWorkFlow && listWorkFlow?.length">
                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                      [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                      aria-label="Select page">
                    </mat-paginator>
                  </div>
                  <app-empty-state *ngIf="listWorkFlow && !listWorkFlow?.length" [title]="parentItem"></app-empty-state>
                </div>
              </div>
            </div>


          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
      </div>
      <!--end::Content container-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Content wrapper-->
  <!--end:::Main-->
</div>